module.exports = __webpack_public_path__ + "media/icons/chat@2x-ca3df9bd.png";